import React, { useRef } from "react";
import {
  Flex,
  Text,
  Grid,
  GridItem,
  Button,
  Box,
  Divider,
} from "@chakra-ui/react";
import styles from "./AboutPage.module.css";
import Footer from "../components/Footer";

import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function AboutPage() {
  return (
    <Flex className={styles.container}>
      <Flex className={styles.headerSection}>
        <Flex className={styles.headerTextContainer}>
          <Text className={styles.headerText}>
            KURIA KOMPOSIT TEKNOLOGI INDONESIA :
          </Text>
          <Text className={styles.headerTitleText}>Pionir GFRP Indonesia</Text>
          <Text className={styles.headerDesc}>
            Merupakan{" "}
            <span className={styles.headerDesc2}>
              manufaktur pertama di Indonesia{" "}
            </span>
            yang memproduksi GFRP Rebar dan GFRP Mesh untuk kebutuhan
            infrastruktur dan konstruksi.
          </Text>
          <Text className={styles.headerDesc} paddingTop={"16px"}>
            Kami menghadirkan inovasi material komposit yang kuat, ringan, dan
            tahan korosi sebagai solusi masa depan untuk Indonesia dan dunia.
          </Text>
        </Flex>
        <img className={styles.headerImg} src="/assets/about/aboutBanner.png" />
      </Flex>

      {/* Client Section  */}
      <Flex className={styles.clientSection}>
        <Text className={styles.clientText}>
          Mitra Terpercaya <br /> Banyak Perusahaan
        </Text>
        <Flex className={styles.clientImgContainer}>
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo1.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo2.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo3.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo4.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo5.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo6.png"
          />
        </Flex>
        <Flex className={styles.clientImgContainer} paddingTop="36px">
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo7.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo8.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo9.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo10.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo11.png"
          />
          <img
            className={styles.clientImg}
            src="/assets/about/clients/about_logo12.png"
          />
        </Flex>
      </Flex>

      {/* Greetings Section  */}
      <Flex className={styles.greetingsSection}>
        <Flex className={styles.greetingsLeft}>
          <img
            className={styles.greetingsImg}
            src="/assets/about/about_CEO.png"
          />
          <Flex className={styles.greetingsTextContainer}>
            <Text className={styles.greetingsText}>Salam hangat,</Text>
            <Text className={styles.greetingsText2}>Saya Stephen Pratama</Text>
            <Text className={styles.greetingsText3}>
              CO-FOUNDER & DIRECTOR PT KURIA
            </Text>
          </Flex>
        </Flex>
        <Flex className={styles.greetingsRight}>
          <Text className={styles.greetingsPara}>
            PT Kuria hadir sebagai pionir dalam menghadirkan solusi tulangan
            inovatif di Indonesia. Produk unggulan kami, KURIA Bar, telah
            terbukti mampu memberikan kinerja yang jauh lebih baik dibandingkan
            tulangan baja konvensional. Dengan kekuatan tarik yang tinggi, tahan
            terhadap korosi, dan ramah lingkungan, KURIA Bar menjadi pilihan
            yang tepat untuk berbagai proyek konstruksi. Sebagai perusahaan yang
            berorientasi pada pelanggan, kami selalu berupaya untuk memberikan
            pelayanan terbaik, mulai dari proses konsultasi hingga pasca
            penjualan. Kami berkomitmen untuk terus mengembangkan produk dan
            layanan kami agar dapat memenuhi kebutuhan pelanggan yang terus
            berkembang.
          </Text>
          <Text className={styles.greetingsClosing}>Hormat Kami,</Text>
          <Text className={styles.greetingsText4}>
            Co-Founder & Director PT Kuria Komposit
          </Text>
          <Text className={styles.greetingsText4}>Teknologi Indonesia</Text>
        </Flex>
      </Flex>

      {/* Values Section  */}
      <Flex className={styles.valuesSection}>
        <Text className={styles.valuesTitle}>Visi Misi</Text>
        <Flex className={styles.visionMission}>
          <Flex className={styles.visionCard}>
            <Text className={styles.visionTitle}>VISI</Text>
            <Text className={styles.visionText}>
              Menjadi produsen terkemuka komponen komposit berkualitas tinggi
              untuk industri konstruksi.
            </Text>
          </Flex>
          <Flex className={styles.visionCard}>
            <Text className={styles.visionTitle}>MISI</Text>
            <Text className={styles.visionText}>
              Menyediakan solusi inovatif yang meningkatkan kekuatan, daya
              tahan, dan keberlanjutan struktur bangunan.
            </Text>
          </Flex>
        </Flex>
      </Flex>

      {/* Our Journey  */}
      <Flex className={styles.journeySection}>
        <Text className={styles.journeyTitle}>Perjalanan Kuria</Text>
        <Flex className={styles.journeyContainer}>
          <JourneyCard
            year="2022"
            img="/assets/about/journey/journey_2022.png"
            desc="Mengenal GFRP Rebar pertama kali, tim melakukan riset produk yang mendalam, melihat potensi besarnya untuk menggantikan tulangan baja konvensional di Indonesia."
          />
          <Divider opacity={0.5} />
          <JourneyCard
            year="2023"
            img="/assets/about/journey/journey_2023.png"
            desc="Menyediakan solusi inovatif yang meningkatkan kekuatan, daya tahan, dan keberlanjutan struktur bangunan."
          />
          <Divider opacity={0.5} />
          <JourneyCard
            year="2024"
            img="/assets/about/journey/journey_2024.png"
            desc="Kami terus memperluas jangkauan pasar ke berbagai wilayah di Indonesia dan mengembangkan produk-produk baru yang lebih inovatif."
          />
          <Divider opacity={0.5} />
          <JourneyCard
            year="2025"
            img="/assets/about/journey/journey_2025.png"
            desc="Melakukan ekspansi berskala besar dengan mendatangkan mesin-mesin baru untuk meningkatkan kapasitas produksi, pindah ke fasilitas baru, serta pengembangan riset produk  baru."
          />
        </Flex>
      </Flex>

      {/* Call Out Banner */}
      <Flex className={styles.callOutBanner}>
        <Flex className={styles.callOutTextContainer}>
          <Text className={styles.callOutText}>
            Revolusi Konstruksi Dengan Kuria
          </Text>
          <CallOutButton />
        </Flex>
      </Flex>

      <Footer />
    </Flex>
  );
}

function JourneyCard({ year, img, desc }) {
  return (
    <Grid className={styles.journeyCard}>
      <Text className={styles.yearText}>{year}</Text>
      <img className={styles.journeyImg} src={img} />
      <Text className={styles.journeyDesc}>{desc}</Text>
    </Grid>
  );
}

function CallOutButton() {
  return (
    <Box
      as="button"
      className={styles.callOutButton}
      transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
      _hover={{ bg: "#ebedf0" }}
      _active={{
        bg: "#dddfe2",
        transform: "scale(0.98)",
        borderColor: "#bec3c9",
      }}
      _focus={{
        boxShadow:
          "0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .15)",
      }}
    >
      <a href="/contact">KONTAK KURIA</a>
    </Box>
  );
}
